'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import CommonContainer from '@components/CommonContainer';
import { CustomRegistration } from '@components/CustomRegistration';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';
export const OGAMI_REGISTRATION_ID = 'ogamiRegistrationID';
export default function OgamiRegistration(props: any) {
  const registrationSection = props?.locale?.section?.find(
    (section: any) => section.type === 'registration' && section.enabled
  );
  if (!registrationSection) return null;
  const { links, leadConfig } = props;
  return (
    <Stack
      component="section"
      className={cn.ogamiRegistrationWrapper}
      id={OGAMI_REGISTRATION_ID}
    >
      <Box className={cn.ogamiRegistrationInner}>
        <CommonContainer
          paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
          maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.ogamiRegistrationBody}>
            <Box className={cn.ogamiRegistrationHeading}>
              <Box className={cn.ogamiRegistrationHeading__title}>
                <Mobile>
                  <ParallaxText
                    variant="h2"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      registrationSection?.ogamiBannerRegisterHeadingMobile
                    )}
                  </ParallaxText>
                </Mobile>
                <Desktop>
                  <ParallaxText
                    variant="h2"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      registrationSection?.ogamiBannerRegisterHeadingDesktop
                    )}
                  </ParallaxText>
                </Desktop>
              </Box>
              <Box className={cn.ogamiRegistrationHeading__data}>
                <ParallaxText
                  variant="h5"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    registrationSection?.ogamiBannerRegisterSubHeading
                  )}
                </ParallaxText>
              </Box>
            </Box>
            <Box className={cn.ogamiRegistrationContent}>
              <Box className={cn.ogamiRegistrationForms}>
                <CustomRegistration
                  t={registrationSection}
                  scrollId={OGAMI_REGISTRATION_ID}
                  successPopUpLink={links.successPopupRedirection}
                  privacyPolicyLink={links.privacyPolicy}
                  termsAndConditionsLink={links.termsAndConditions}
                  formId={leadConfig.formId}
                  formType={leadConfig.formType}
                  projectName={leadConfig.projectName}
                  variant="modal"
                  className={cn.ogamiRegistrationOuter}
                  listClassName={cn.ogamiRegistrationList}
                  blockClassName={cn.ogamiRegistrationBlock}
                  inputClassName={cn.ogamiRegistrationInput}
                  elementClassName={cn.ogamiRegistrationElement}
                  submitBlockClassName={cn.ogamiRegistrationSubmitBlock}
                  submitClassName={cn.ogamiRegistrationButton}
                  marksClassName={cn.ogamiRegistrationMarks}
                  wrapperClassName={cn.ogamiRegistrationSuccessWrapper}
                  contentClassName={cn.ogamiRegistrationSuccessContent}
                  buttonClassName={cn.ogamiRegistrationSuccessButton}
                />
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
